import { svgCustomEdgeType } from "react-xarrows";

const CustomArrowShape: svgCustomEdgeType = { svgElem: <polygon points="-3, -2 2, 0.5 -3, 3" />, offsetForward: 0 };

export default CustomArrowShape;
